import { Component } from '@angular/core';

@Component({
  selector: 'app-samples-wrapper',
  templateUrl: './sample-records-wrapper.component.html',
  styleUrls: ['./sample-records-wrapper.component.scss'],
  standalone: false,
})
export class SampleRecordsWrapperComponent {}
